(() => {
  const hiddenTrackingHosts = new Set([
    "ad-srv.net",
    "pixel.bsmartdata.com"
  ]);

  const isHiddenTrackingFrame = (frame) => {
    try {
      const hostname = new URL(frame.src, window.location.href).hostname;
      return Array.from(hiddenTrackingHosts).some((host) => hostname === host || hostname.endsWith(`.${host}`));
    } catch (error) {
      return false;
    }
  };

  const makeTrackingFrameInert = (frame) => {
    if (frame instanceof HTMLIFrameElement && !frame.title.trim()) {
      try {
        const source = new URL(frame.src, window.location.href);
        if (source.hostname === 'cdn.shopify.com' && source.pathname.startsWith('/shopifycloud/preview-bar/')) {
          frame.title = window.themeVariables.strings.themePreview;
        }
      } catch (error) {
        // A frame without a usable source is not labelled speculatively.
      }
    }
    if (!(frame instanceof HTMLIFrameElement) || !isHiddenTrackingFrame(frame)) {
      return;
    }

    if (frame.getAttribute("tabindex") !== "-1") {
      frame.setAttribute("tabindex", "-1");
    }

    if (frame.getAttribute("aria-hidden") !== "true") {
      frame.setAttribute("aria-hidden", "true");
    }
  };

  const inspectNodeForTrackingFrames = (node) => {
    if (!(node instanceof Element)) {
      return;
    }

    makeTrackingFrameInert(node);
    node.querySelectorAll("iframe").forEach(makeTrackingFrameInert);
  };

  document.querySelectorAll("iframe").forEach(makeTrackingFrameInert);

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === "attributes") {
        makeTrackingFrameInert(mutation.target);
      } else {
        mutation.addedNodes.forEach(inspectNodeForTrackingFrames);
      }
    });
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["src", "tabindex", "aria-hidden"]
  });

  // The theme moves drawers to <body> while they are open and restores them to
  // their original parent after closing. That reconnect can cancel the focus
  // trap's own return-focus step, so remember and restore the opener explicitly.
  const dialogReturnFocusTargets = new WeakMap();

  document.addEventListener("dialog:before-show", (event) => {
    const dialog = event.target;
    if (!(dialog instanceof HTMLElement)) {
      return;
    }

    const activeElement = document.activeElement;
    const fallbackControl = dialog.id
      ? document.querySelector(`[aria-controls="${CSS.escape(dialog.id)}"]`)
      : null;
    const returnFocusTarget = activeElement instanceof HTMLElement
      && activeElement !== document.body
      && activeElement !== document.documentElement
      && !dialog.contains(activeElement)
      ? activeElement
      : fallbackControl;

    if (returnFocusTarget instanceof HTMLElement) {
      dialogReturnFocusTargets.set(dialog, returnFocusTarget);
    }
  }, true);

  document.addEventListener("dialog:after-hide", (event) => {
    const dialog = event.target;
    if (!(dialog instanceof HTMLElement)) {
      return;
    }

    const returnFocusTarget = dialogReturnFocusTargets.get(dialog);
    dialogReturnFocusTargets.delete(dialog);

    if (!(returnFocusTarget instanceof HTMLElement)) {
      return;
    }

    window.requestAnimationFrame(() => {
      const activeElement = document.activeElement;
      const focusWasLost = activeElement === document.body
        || activeElement === document.documentElement
        || dialog.contains(activeElement);

      if (!dialog.hasAttribute("open") && returnFocusTarget.isConnected && focusWasLost) {
        returnFocusTarget.focus({ preventScroll: true });
      }
    });
  }, true);

  const cartStatus = document.getElementById("cart-status");
  let announcementTimer;

  const formatCartTotal = (cents) => {
    const amount = Number(cents) / 100;
    const locale = document.documentElement.lang || window.Shopify?.locale || navigator.language;
    const currency = window.Shopify?.currency?.active || "EUR";

    try {
      return new Intl.NumberFormat(locale, { style: "currency", currency }).format(amount);
    } catch (error) {
      return `${amount.toFixed(2)} ${currency}`;
    }
  };

  const getLineItemName = (item) => {
    const productTitle = item.product_title || item.title || "";
    const variantTitle = item.variant_title;

    if (!variantTitle || variantTitle === "Default Title" || productTitle.includes(variantTitle)) {
      return productTitle;
    }

    return `${productTitle}, ${variantTitle}`;
  };

  document.addEventListener("variant:add", (event) => {
    if (!cartStatus) {
      return;
    }

    const items = Array.isArray(event.detail?.items) ? event.detail.items : [];
    const cart = event.detail?.cart;

    if (!cart || items.length === 0) {
      return;
    }

    const productName = items.map(getLineItemName).filter(Boolean).join(", ");
    const itemCount = Number(cart.item_count);
    const template = itemCount === 1 ? window.themeVariables.strings.cartStatusOne : window.themeVariables.strings.cartStatusOther;
    const message = template
      .replace("__PRODUCT__", productName)
      .replace("__COUNT__", String(itemCount))
      .replace("__TOTAL__", formatCartTotal(cart.total_price));

    window.clearTimeout(announcementTimer);
    cartStatus.textContent = "";
    announcementTimer = window.setTimeout(() => {
      cartStatus.textContent = message;
    }, 50);
  });
})();
